// import { REPORT_CHANNEL, ZT_ROOT_ADDRESS } from '@src/constants';
// import queryParams from '@src/utils/getAppId';
import { LANGUAGE_NAME } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

export const config = {
  appId: '111111681',
  appVersion: '1.0',
  channel: 'pc',
  createCommonAttributes: () => {
    return {
      //
      language: LANGUAGE_NAME[getLanguageByPath()]
      //post_url: ZT_ROOT_ADDRESS
    };
  }
};

const gaTrackerBaseEvent = {
  // 发送埋点
  send: (event_name, event_options) => {
    // eslint-disable-next-line no-undef
    if (window.dataLayer) {
      // eslint-disable-next-line no-undef
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('event', event_name, event_options);
    }
  }
};

let startTimeTpl = 0;

export default function createTracker(report, getDiffRouteTime) {
  return {
    //首页-立即预约/下载
    clickDownload: function() {
      gaTrackerBaseEvent.send('click_download');
    },
    // 弹窗-取得验证码
    clickYzm: function() {
      gaTrackerBaseEvent.send('click_yzm');
    },
    // 弹窗-立即预约/下载
    clickLjyy: function() {
      gaTrackerBaseEvent.send('click_ljyy');
    },
    // 主页-STEAM
    clickSTEAM: function() {
      gaTrackerBaseEvent.send('click_STEAM');
    },
    // 主页-XBOX
    clickXbox: function() {
      gaTrackerBaseEvent.send('click_xbox');
    },
    // 主页-Twithc Drops
    clickTD: function() {
      gaTrackerBaseEvent.send('click_TD');
    },
    // 主页-创作者招募
    clickCzz: function() {
      gaTrackerBaseEvent.send('click_czz');
    },
    // 私域弹窗-discord
    clickDiscord: function() {
      gaTrackerBaseEvent.send('click_discord');
    },
    // 私域弹窗-youtube
    clickYoutube: function() {
      gaTrackerBaseEvent.send('click_youtube');
    },
    // 私域弹窗-X
    clickXxx: function() {
      gaTrackerBaseEvent.send('click_xxx');
    },
    pageLoadDuration: function(region) {
      const endTimeTpl = new Date().getTime();
      startTimeTpl = new Date().getTime();
      const tpl = endTimeTpl - startTimeTpl;
      const customEventInfo = {
        eventId: 'page_load_duration', //事件ID
        eventDesc: '用户点进来页面loading加载时长', //事件描述
        eventBody: {
          td_pl: getDiffRouteTime(),
          region: region
        }
      };
      report(customEventInfo);
      // gaTrackerBaseEvent.send('click_start_code');
    },
    clickMESSAGE: function() {
      // const customEventInfo = {
      //   eventId: 'click_dlcmsmk_register', //事件ID
      //   eventDesc: '首页-测试报名，需要可区分五语言（繁中、英语、日语、韩语葡萄牙语）查看数据', //事件描述
      //   eventBody: {}
      // };
      // report(customEventInfo);
      gaTrackerBaseEvent.send('click_MESSAGE');
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
